import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useEvent } from '@hooks/useEvent'
import { itemActions } from '../../AES_App/reducer/ItemSlice'
import { addExtraSpace } from '../utils'
import { CURRENT_INVOICE } from '@commonComponents/copyRepElement'

export const useMultipleMerchandiseItem = ({ invoiceId, merchandiseId }) => {
  const { isLoading, saveForm, deleteForm } = useEvent('invoiceTab', true)
  const dispatch = useDispatch()
  // const { updateInvoiceUpperHeader, updateInvoiceHeader } = itemActions
  // const { addMerchanidseDocById, deleteMerchanidseDocById, updateMerchanidseDocById, massUpdateDocument } = itemActions
  const {
    addMerchanidseDocById,
    deleteMerchanidseDocById,
    updateMerchanidseDocById,
    updateInvoiceUpperHeader,
    updateInvoiceHeader,
    massUpdateDocument
  } = itemActions
  const addItem = useCallback(
    async (tableName, params) => {
      try {
        const event = ''
        const response = await saveForm(
          {
            merchandiseMap: {
              [`${merchandiseId}`]: {
                invoiceId,
                [`${tableName}`]: [
                  {
                    id: '',
                    merchandiseId,
                    invoiceId,
                    ...params,
                  },
                ],
              },
            },
          },
          true,
          event
        )
        if (response) {
          const data = response.invoiceTab.merchandiseMap[merchandiseId][tableName][0]
          dispatch(
            addMerchanidseDocById({
              data: { ...data, invoiceId, merchandiseId, ...params },
              meta: { tableName },
            })
          )
          // callback && callback(response)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [invoiceId, merchandiseId]
  )

  const deleteItem = useCallback(
    async (id, tableName) => {
      try {
        const response = await deleteForm({
          merchandiseMap: {
            [`${merchandiseId}`]: {
              [`${tableName}`]: [
                tableName === 'containersList' ? { containerAssociationId: id } : { id },
              ],
            },
          },
        })
        if (response)
          dispatch(
            deleteMerchanidseDocById({
              id,
              data: { invoiceId, merchandiseId },
              meta: { tableName },
            })
          )
        const invoiceUpperHeader = response?.invoiceTab?.invoiceUpperHeader
        invoiceUpperHeader && dispatch(updateInvoiceUpperHeader(invoiceUpperHeader))
        const invoiceMap = response?.invoiceTab?.invoiceMap
        const invoiceHeader = (invoiceMap && invoiceMap[invoiceId]?.invoiceHeader) || ''
        invoiceHeader && dispatch(updateInvoiceHeader({ invoiceId, data: invoiceHeader }))
      } catch (e) {}
    },
    [invoiceId, merchandiseId]
  )

  const updateItem = useCallback(
    (id, tableName, payload) => {
      try {
        dispatch(
          updateMerchanidseDocById({
            id,
            data: { ...addExtraSpace(payload), invoiceId, merchandiseId },
            meta: { tableName },
          })
        )
        
      } catch (e) {
        console.log(e)
      }
    },
    [invoiceId, merchandiseId]
  )

  const saveItem = useCallback(
    async (tableName, payload) => {
      try {
        const response = await saveForm(
          {
            merchandiseMap: {
              [`${merchandiseId}`]: {
                invoiceId: invoiceId,
                [`${tableName}`]: Array.isArray(payload) ? addExtraSpace(payload) : [addExtraSpace(payload)],
              },
            },
          },
          false
        )
        const invoiceUpperHeader = response?.invoiceTab?.invoiceUpperHeader
        invoiceUpperHeader && dispatch(updateInvoiceUpperHeader(invoiceUpperHeader))
        const invoiceMap = response?.invoiceTab?.invoiceMap
        const invoiceHeader = (invoiceMap && invoiceMap[invoiceId]?.invoiceHeader) || ''
        invoiceHeader && dispatch(updateInvoiceHeader({ invoiceId, data: invoiceHeader }))
      } catch {}
    },
    [invoiceId, merchandiseId]
  )

  const onSelect = useCallback(async (id, tableName, payload) => {
    try {
      updateItem(id, tableName, addExtraSpace(payload))
      const response = await saveItem(tableName, payload)
    } catch {}
  }, [])

  // copyData
  const addCopyItem = useCallback(
    async (tableName, params, option) => {
      try {
        const eventType = ['dangerousGoodsCodesList','packagesList'].includes(tableName)? 'COPY_FEATURE':''
        const response = await saveForm(
          {
            [`${option}`]: true,
            merchandiseMap: {
              [`${merchandiseId}`]: {
                invoiceId,
                [`${tableName}`]: [
                  {
                    id: '',
                    merchandiseId,
                    invoiceId,
                    ...params,
                  },
                ],
              },
            },
          },
          true,
          eventType
        )
        if (response) {
          return response
        }
      } catch (e) {
        console.log(e)
      }
    },
    [invoiceId, merchandiseId]
  )

  const copyData = useCallback(async (copyFor, params, tableName) => {
    const option = copyFor === CURRENT_INVOICE ? 'copyToInvoice' : 'copyToAllInvoice'
    const response = await addCopyItem(tableName, params, option)
    
    if (response?.invoiceTab) {
      dispatch(massUpdateDocument({
        merchIdList:response?.invoiceTab?.merchandiseMap || {},
        meta:{tableName}
      }))
    }

  }, [addCopyItem, saveForm, invoiceId, merchandiseId])
  // / copyData

  return React.useMemo(
    () => ({
      addItem,
      deleteItem,
      updateItem,
      saveItem,
      copyData,
      onSelect,
      isLoading,
    }),
    [addItem, deleteItem, updateItem, saveItem, copyData, isLoading]
  )
}
